export enum TRACKING_EVENT_TYPE {
  PerformerSearch = "performer-search",
}

export enum TRACKING_VALUES {
  PremierMember = "premier-member",
  ClassicMember = "classic-member",
}
